import { useDispatch, useSelector } from '@tmapy/redux';

import type { MapSwitcherActions } from '@tmapy/map-switcher';
import { MapSwitcher } from '@tmapy/map-switcher';
import { PANEL } from '@tmapy/config';

type Dispatch = (action: MapSwitcherActions) => void;

export const MapSwitcherWithStore: React.FC = () => {
  const dispatch: Dispatch = useDispatch();
  // TODO: Refactor to CSS $TW_LAYOUT_BP_SML
  const mobileBreakpoint = 900;

  const mapSwitcher = useSelector((state) => state.mapSwitcher);
  const layers = useSelector((state) => state.mapCore.layers);
  const appId = useSelector((state) => state.app.appId);
  const visiblePanel = useSelector((state) => state.uiManager.visiblePanel);

  return (
    <MapSwitcher
      appId={appId}
      mapSwitcher={mapSwitcher}
      layers={layers}
      dispatch={dispatch}
      isAnotherPanelVisible={visiblePanel !== PANEL.NONE}
      mobileBeakpoint={mobileBreakpoint}
    />
  );
};
